'use strict';


export default function(anti) {
	return function() {
		return {
			require: '^expansionContainer',
			transclude: true,
			template: `
				<div uib-collapse="${anti?'':'!'}$expansion.expanded">
					<div ng-transclude></div>
				</div>`,
		};
	}
}
